import React, { Component } from "react";
import {Button, Row, Col, Modal} from 'react-bootstrap'
import _ from 'lodash';

import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

export default class ReAssign extends Component { 
  constructor(props){
    super(props)
   this.state= {
    selectedTemplate:[]
  }
}
componentWillMount(){
  this.props.action.TokenValidation()  
  this.props.action.formNames()
}
UNSAFE_componentWillReceiveProps (){
  let selected = _.find(this.props.webFormNames, {'name':this.props.data.form.title})
  if(!_.isEmpty(selected)){
    this.setState({selectedTemplate:selected})
  }
}

handleSelectTemplate = (e) => {
  this.setState({selectedTemplate: e});
}
reAssign = () => {
  const{data} = this.props;
  let obj = {'region':data.region, 'center':[data.center], 'client':[data.client], 
  'process':[data.process], 'title':this.state.selectedTemplate.name,
  'formId':this.state.selectedTemplate.id
}
  this.props.action.TokenValidation()  
  this.props.action.mapTemplate(obj, this.props.mapRequest)  
  this.props.closeModal()
  this.setState({selectedTemplate:[]})
}
 render(){
   const {data} = this.props
   return(
    <Modal
    show={true}
    onHide={this.props.closeModal}
    dialogClassName={"modal-90w "}
    size={"lg"}
    //aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Header closeButton>
    <Modal.Title id="example-custom-modal-styling-title">
    'Replace Web Form'
    </Modal.Title>
    </Modal.Header>
    <Modal.Body>  
   <div className='margingap'>
   <Row>
     <Col><Row>
     <Col md={3}>Region</Col>
     <Col md={1}>:</Col>
     <Col>{data.region.label}</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Center</Col>
     <Col md={1}>:</Col>
     <Col>{data.center.label}</Col></Row></Col>
  </Row>
  <Row>
     <Col><Row>
     <Col md={3}>Client</Col>
     <Col md={1}>:</Col>
     <Col>{data.client.label}</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Process</Col>
     <Col md={1}>:</Col>
     <Col>{data.process.label}</Col></Row></Col>
   </Row>
    <Row>
   <Col>
   Web Forms
   </Col>
   <Col>
   <Picky keepOpen={false}
     value={this.state.selectedTemplate}
     options={this.props.webFormNames}
     onChange={this.handleSelectTemplate}
     open={false}
     valueKey="id"
     labelKey="name"
     multiple={false}
     includeSelectAll={false}
     includeFilter={false}
     placeholder='Select Web Form'
     dropdownHeight={600}
   />
    </Col>
    </Row>
    <br/>
    <Button onClick={this.reAssign} className='buttonwidth' block>Replace Web Form</Button>
    </div>    
    </Modal.Body>
    </Modal>
    )
 }
}    

